import React from "react";
import { Redirect } from "react-router-dom";




// Inner Authentication

import Login2 from "../pages/super-admin/login/Login2";

import DepartmentList from "pages/super-admin/master/department/DepartmentList";
import AddDepartment from 'pages/super-admin/master/department/AddDepartment'
import AdminLogin from "pages/admin-pages/login/AdminLogin";
import Dashboard from "pages/Dashboard-crypto";
import AdminDashboard from "pages/admin-pages/dashboard/AdminDashboard";
import BloodTextReport from "pages/admin-pages/test-report/BloodTestReport";
import DoctorList from "pages/admin-pages/doctor/DoctorList";
import AddDoctor from "pages/admin-pages/doctor/AddDoctor";
import UpdateDoctor from "pages/admin-pages/doctor/UpdateDoctor";
import PatientList from "pages/admin-pages/patient/PatientList";
import AddPatient from "pages/admin-pages/patient/AddPatient";
import UpdatePatient from "pages/admin-pages/patient/UpdatePatient";
import UpdateDepartment from "pages/super-admin/master/department/UpdateDepartment";
import AdminDepartmentList from "pages/admin-pages/master/department/AdminDepartmentList";
import AdminAddDepartment from "pages/admin-pages/master/department/AdminAddDepartment";
import AdminUpdateDepartment from "pages/super-admin/master/department/UpdateDepartment";
import AdminDesignationList from "pages/admin-pages/master/designation/AdminDesignationList";
import AdminAddDesignation from "pages/admin-pages/master/designation/AdminAddDesignation";
import AdminUpdateDesignation from "pages/admin-pages/master/designation/AdminUpdateDesignation";
import DesignationList from "pages/super-admin/master/designation/DesignationList";
import AddDesignation from "pages/super-admin/master/designation/AddDesignation";
import UpdateDesignation from "pages/super-admin/master/designation/UpdateDesignation";
import PathologyList from "pages/super-admin/pathology/PathologyList";
import AddPathology from "pages/super-admin/pathology/AddPathology";
import UpdatePathology from "pages/super-admin/pathology/UpdatePathology";
import SuperAdminDashboard from "pages/super-admin/dashboard/SuperAdminDashboard";
import ModuleList from "pages/super-admin/module/ModuleList";
import AddModule from "pages/super-admin/module/AddModule";
import { replace } from "lodash";
import HairTestReport from "pages/admin-pages/test-report/hair-report/HairTestReport";
import Subscription from "pages/admin-pages/subscription/Subscription";
import TissueBiopsyTest from "pages/admin-pages/test-report/tissue-biopsy/TissueBiopsyTest";
import TestList from "pages/admin-pages/master/test/TestList";
import AddTest from "pages/admin-pages/master/test/AddTest";
import UpdateTest from "pages/admin-pages/master/test/UpdateTest";

const authProtectedRoutes = [

  // SUPER-ADMIN ROUTE

  { path: "/superadmin/dashboard", component: SuperAdminDashboard },

  { path: "/superadmin/department-list", component: DepartmentList },
  { path: "/superadmin/add-department", component: AddDepartment },
  { path: "/superadmin/update-department", component: UpdateDepartment },

  { path: "/superadmin/designation-list", component: DesignationList },
  { path: "/superadmin/add-designation", component: AddDesignation },
  { path: "/superadmin/update-designation", component: UpdateDesignation },

  { path: "/superadmin/pathology-list", component: PathologyList },
  { path: "/superadmin/add-pathology", component: AddPathology },
  { path: "/superadmin/update-pathology", component: UpdatePathology },

  { path: "/superadmin/module-list", component: ModuleList },
  { path: "/superadmin/add-module", component: AddModule },
  // { path: "/superadmin/update-module", component: Updatemodule },







  // ADMIN ROUTE

  { path: "/", component: AdminDashboard },
  { path: "/admin/dashboard", component: AdminDashboard },
  { path: "/admin/test-report", component: BloodTextReport },
  { path: "/admin/subscription", component: Subscription },

  { path: "/admin/hair-test", component: HairTestReport },
  { path: "/admin/tissue-biopsy-test", component: TissueBiopsyTest },

  { path: "/admin/test-list", component: TestList },
  { path: "/admin/add-test", component: AddTest },
  { path: "/admin/update-test", component: UpdateTest },


  { path: "/admin/department-list", component: AdminDepartmentList },
  { path: "/admin/add-department", component: AdminAddDepartment },
  { path: "/admin/update-department", component: AdminUpdateDepartment },

  { path: "/admin/designation-list", component: AdminDesignationList },
  { path: "/admin/add-designation", component: AdminAddDesignation },
  { path: "/admin/update-designation", component: AdminUpdateDesignation },

  { path: "/admin/doctor-list", component: DoctorList },
  { path: "/admin/add-doctor", component: AddDoctor },
  { path: "/admin/update-doctor", component: UpdateDoctor },

  { path: "/admin/patient-list", component: PatientList },
  { path: "/admin/add-patient", component: AddPatient },
  { path: "/admin/update-patient", component: UpdatePatient },



];

const publicRoutes = [



  // { path: "/",  component: AdminLogin },
  { path: "/admin/login", component: AdminLogin },
  { path: "/superadmin/login", component: Login2 },

];

export { authProtectedRoutes, publicRoutes };